import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { useFormatCurrency } from '../../../../hooks/useFormatCurrency';
import { closeDialog } from '../../../../store/actionCreators/dialogManager';
import { jacpotsRequest } from '../../../../store/actionCreators/jackpot';
import { requestReadMessage } from '../../../../store/actionCreators/messages';
import { getSpinAndGoConfigsRequest } from '../../../../store/actionCreators/spinAndGoConfigs';
import { resetToggleJackpotGameFromHost } from '../../../../store/actionCreators/toggleJackpotGameFromHost';
import { resetTournamentGameUrl } from '../../../../store/actionCreators/tournamentGameUrl';
import { getOpenTournamentGameId, getTournamentGameUrl } from '../../../../store/selectors';
import './Jackpot.scss';

const TournamentEndJackpot = ({ payload, dialogKey, tournament }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const formatCurrency = useFormatCurrency();
    const { addToast  } = useToasts();
    const tournamentGameUrl = useSelector(getTournamentGameUrl);
    const openTournamentGameId = useSelector(getOpenTournamentGameId);

    const onClose = useCallback(() => {
        if (payload?.messageId) {
            dispatch(requestReadMessage(payload.messageId));
        }
        dispatch(closeDialog('tournamentFinished'));
        dispatch(closeDialog(dialogKey));
        if (!(tournamentGameUrl && String(payload?.tournamentId) === String(openTournamentGameId))) {
            dispatch(jacpotsRequest());
            dispatch(getSpinAndGoConfigsRequest());
        }
    }, [dispatch, tournamentGameUrl, payload, openTournamentGameId]);

    useEffect(() => {
        if (tournamentGameUrl && String(payload?.tournamentId) === String(openTournamentGameId)) {
            dispatch(resetTournamentGameUrl());
            dispatch(resetToggleJackpotGameFromHost(false));
            dispatch(closeDialog('jackpotTournamentFinished'));
        }
    }, [payload, openTournamentGameId, tournamentGameUrl]);

    useEffect(() => {
        if (payload) {
            addToast(
                <>
                    <p>
                       <span className="tournament-end-jackpot__title">
                        {t(`tournamentEndJackpotDialog.title`, {
                           tournamentName: payload?.tournamentName,
                           tournamentId: payload?.tournamentId,
                            } ?? {}) }
                       </span>
                    </p>
                    <p>
                     <span className="tournament-end-jackpot__win-loss">
                        {payload?.winning?.amount > 0 ? (
                            <>
                                {t('youWon')} {formatCurrency(payload?.winning?.amount, payload?.winning?.currency)}
                            </>
                        ) : (
                            <span>
                                {t('youLose')}
                            </span>
                        )}
                      </span>
                    </p>
                </>,
                {
                    appearance: 'info',
                    autoDismiss: true,
                    id: payload?.tournamentId,
                }
            );

            onClose();
        }
    }, [addToast, payload, formatCurrency, onClose]);

    return null
};

export default TournamentEndJackpot;
